import service from '@/utils/request'

export function counselorStudentExamStatusList(data) {
  return service({
    url: '/api/counselor/student/exam_status/list',
    method: 'post',
    data
  })
}

export function counselorExamList(data) {
  return service({
    url: '/api/counselor/exam/list',
    method: 'post',
    data
  })
}

export function counselorExamStudentList(data) {
  return service({
    url: '/api/counselor/exam/student/list',
    method: 'post',
    data
  })
}
